export default "__VITE_ASSET__CZM9RQBA__"